__turbopack_context__.v({
  "card": "entriesGrid-module__xkUBLW__card",
  "cardBody": "entriesGrid-module__xkUBLW__cardBody",
  "cardExcerpt": "entriesGrid-module__xkUBLW__cardExcerpt",
  "cardMedia": "entriesGrid-module__xkUBLW__cardMedia",
  "cardOverlay": "entriesGrid-module__xkUBLW__cardOverlay",
  "cardTitle": "entriesGrid-module__xkUBLW__cardTitle",
  "cta": "entriesGrid-module__xkUBLW__cta",
  "ctaButton": "entriesGrid-module__xkUBLW__ctaButton",
  "empty": "entriesGrid-module__xkUBLW__empty",
  "featuredBody": "entriesGrid-module__xkUBLW__featuredBody",
  "featuredCard": "entriesGrid-module__xkUBLW__featuredCard",
  "featuredCardPreview": "entriesGrid-module__xkUBLW__featuredCardPreview",
  "featuredExcerpt": "entriesGrid-module__xkUBLW__featuredExcerpt",
  "featuredMedia": "entriesGrid-module__xkUBLW__featuredMedia",
  "featuredTitle": "entriesGrid-module__xkUBLW__featuredTitle",
  "featuredWrap": "entriesGrid-module__xkUBLW__featuredWrap",
  "grid": "entriesGrid-module__xkUBLW__grid",
  "list": "entriesGrid-module__xkUBLW__list",
  "listExcerpt": "entriesGrid-module__xkUBLW__listExcerpt",
  "listItem": "entriesGrid-module__xkUBLW__listItem",
  "listLink": "entriesGrid-module__xkUBLW__listLink",
  "listMain": "entriesGrid-module__xkUBLW__listMain",
  "listThumb": "entriesGrid-module__xkUBLW__listThumb",
  "listTitle": "entriesGrid-module__xkUBLW__listTitle",
  "masonry": "entriesGrid-module__xkUBLW__masonry",
  "masonryItem": "entriesGrid-module__xkUBLW__masonryItem",
  "metaRow": "entriesGrid-module__xkUBLW__metaRow",
  "root": "entriesGrid-module__xkUBLW__root",
  "tag": "entriesGrid-module__xkUBLW__tag",
});
